var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var throttle = require('lodash.throttle');

function SearchForm(el) {
  var t = this;

  t.$el = $(el);
  t.$document = $(document);
  t.$html = $('html');
  t.$closeIcon = t.$el.find('.js-search-disable');
  t.$input = t.$el.find('.js-search-form-input');

  // Focus to input if search form is active
  t.$html.on('searchActive', function() {
    t.$input.focus();
  });

  // Close modal on click to close icon or press escape
  t.$closeIcon.on('click', function() {
    t.close();
  });

  t.$document.on('keyup', function(e) {
    var key = e.which || e.keyCode;

    if (key === 27) {
      if (t.isOpen()) {
        t.close();
        e.stopPropagation();
      }
    }
  });

	var search_message = $('.js-search-message');

	if (!search_message.length && $('.js-search-form')[0]) {
		$('.js-search-form')[0].focus();
	}
}

SearchForm.prototype.isOpen = function() {
  return this.$html.hasClass('js-search-active');
};

SearchForm.prototype.open = function() {
  this.$html.addClass('js-search-active').trigger('searchActive');
};

SearchForm.prototype.close = function() {
  this.$html.removeClass('js-search-active').trigger('searchInactive');
};

module.exports = SearchForm;
